'use strict';

module.exports = function disableBackButton( callback ) {
	var popped = ('state' in window.history), initialURL = location.href;

	//ensure that the url ends with /iq
	if ( window.location.pathname.slice( -1 ) === '/' ) {
		window.history.pushState( null, null, 'iq' );
	}else if ( window.location.pathname.slice( -2 ) !== 'iq' ) {
		window.history.pushState( null, null, window.location.pathname + '/iq' );
	}
	window.history.pushState( null, null, 'iq' );
	var initial_order = window.history.state == null ? 0 : window.history.state.order;
	window.addEventListener( 'popstate', function( event ) {
		if (window.history.state === null || window.history.state.order == initial_order){
			return;
		}
		var initialPop = (!popped && location.href == initialURL);
		if (initialPop){ return; }

		history.pushState( null, null, 'iq' );
		if ( callback ) { callback(); }
	});
};
